import css from "./BootScreen.module.css";

/**
 * Boot splash (B.1.1). Shown while the auth handshake is in flight.
 *
 * Stage 1b — visual scaffold only. Stage 1d wires it to the real auth
 * lifecycle and pixel-art mascot. For now: cyberpunk wordmark + "BUILDING
 * UNIBOOKING" status line + animated progress bar driven by CSS.
 */
interface BootScreenProps {
  /** Optional status line shown under the progress bar (e.g. "Загружаю последнюю DC"). */
  status?: string;
}

export function BootScreen({ status }: BootScreenProps) {
  return (
    <div className={css.root} role="status" aria-live="polite">
      <div className={css.frame}>
        <span className={`${css.corner} ${css.tl}`} aria-hidden="true" />
        <span className={`${css.corner} ${css.tr}`} aria-hidden="true" />
        <span className={`${css.corner} ${css.bl}`} aria-hidden="true" />
        <span className={`${css.corner} ${css.br}`} aria-hidden="true" />

        <h1 className={css.wordmark}>UniBooking</h1>
        <p className={css.tagline}>BUILDING UNIBOOKING</p>

        <div className={css.progress} aria-hidden="true">
          <div className={css.progressBar} />
        </div>

        {status ? <p className={css.status}>{status}</p> : null}
      </div>
    </div>
  );
}
